import { createApp } from 'vue'
import App from './App.vue'
import router from "./router";
import AOS from 'aos'
import 'aos/dist/aos.css'
import i18n from './i18n'
import store from "./state/store";
import Toaster from "@meforma/vue-toaster";
import BootstrapVue3 from 'bootstrap-vue-3';
import VueProgressBar from "@aacassandra/vue3-progressbar";
import vClickOutside from "click-outside-vue3"
import VueApexCharts from "vue3-apexcharts";
import { MaskInput } from 'maska';
import {userService} from './helpers/authservice/user.service'
import ROLECONST from './constants/RoleConstant'
import APICONSTANT from './constants/APIConstant'
import IdleVue from 'idle-vue'

import VueFeather from 'vue-feather';
import Particles from "particles.vue3";
import 'gridjs/dist/theme/mermaid.css';
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css';
import '@/assets/scss/config/default/app.scss';
import '@vueform/slider/themes/default.css';
import "@vueform/multiselect/themes/default.css";
import * as directives from './directives';

import '@/assets/fonts/font.css';

// import { initFirebaseBackend } from './authUtils'
// import { configureFakeBackend } from './helpers/fake-backend';

import axios from "@/shared/api";
import VueAxios from 'vue-axios'

// const firebaseConfig = {
//     apiKey: process.env.VUE_APP_APIKEY,
//     authDomain: process.env.VUE_APP_AUTHDOMAIN,
//     databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
//     projectId: process.env.VUE_APP_PROJECTId,
//     storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//     messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
//     appId: process.env.VUE_APP_APPId,
//     measurementId: process.env.VUE_APP_MEASUREMENTID
// };

// if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
//     initFirebaseBackend(firebaseConfig);
// } else {
//     configureFakeBackend();
// }
const options = {
    color: "#bffaf3",
    failedColor: "#874b4b",
    thickness: "5px",
    transition: {
      speed: "0.2s",
      opacity: "0.6s",
      termination: 300,
    },
    autoRevert: true,
    location: "top",
    inverse: false,
  };

AOS.init({
    easing: 'ease-out-back',
    duration: 1000
})

const app =createApp(App)

app.use(VueProgressBar, options)
    .use(IdleVue,{
      store,
      idleTime:600000,
      startAtIdle: false
    })
    .use(store)
    .use(router)
    .use(VueApexCharts)
    .use(BootstrapVue3)
    .component(VueFeather.type, VueFeather)
    .use(Particles)
    .use(i18n)
    .use(vClickOutside)
    .use(Toaster)
    .use(VueAxios, axios)
    app.config.globalProperties.$hasRole =userService.checkrole;
    app.config.globalProperties.$ROLECONSTANT = ROLECONST;
    app.config.globalProperties.$API = APICONSTANT;
     for (const key in directives) {
        app.directive(key, directives[key]);
    }

app.directive('maska', MaskInput);

export default  app.mount('#app')
